import { StatusTone } from '@/components/ui/statusTone.ts';
import { PlannedTransactionPaymentStatus } from '@/features/public/bookingSummary/types/PlannedTransactionPaymentStatus.ts';

/**
 * Etykiety i tony statusu zaplanowanej płatności — jedno miejsce dla tabeli
 * planowanych transakcji i publicznego podsumowania rezerwacji.
 *
 * Moduł zmian rezerwacji mówi o *racie*, więc odmienia te napisy w rodzaju
 * żeńskim („Opłacona”) i trzyma własną mapę w
 * `bookingChanges/types/BillViewModel.utils.ts`.
 */
export const PLANNED_TRANSACTION_PAYMENT_STATUS_LABELS: Record<
  PlannedTransactionPaymentStatus,
  string
> = {
  [PlannedTransactionPaymentStatus.AWAITING_PAYMENT]: 'Oczekuje',
  [PlannedTransactionPaymentStatus.PAID]: 'Opłacone',
  [PlannedTransactionPaymentStatus.OVERDUE]: 'Zaległe',
  [PlannedTransactionPaymentStatus.CANCELLED]: 'Anulowane',
};

export const getPlannedTransactionPaymentStatusLabel = (
  status: PlannedTransactionPaymentStatus,
): string => PLANNED_TRANSACTION_PAYMENT_STATUS_LABELS[status];

export const PLANNED_TRANSACTION_PAYMENT_STATUS_TONE: Record<
  PlannedTransactionPaymentStatus,
  StatusTone
> = {
  [PlannedTransactionPaymentStatus.AWAITING_PAYMENT]: 'warning',
  [PlannedTransactionPaymentStatus.PAID]: 'success',
  [PlannedTransactionPaymentStatus.OVERDUE]: 'error',
  [PlannedTransactionPaymentStatus.CANCELLED]: 'neutral',
};
